$(document).ready(function () {
	$('.vg-catalog-reviews .btn-load-more').click(function () {
		let $items = $("#vg-catalog-reviews--content .vg-catalog-reviews--item.d-none");

		$items.slice(0, 5).removeClass('d-none');

		if ($items.length <= 5)
			$(this).hide();
	});
});